module.exports = __webpack_public_path__ + "static/media/google.4fed5853.svg";